import { SortingOrder } from './common.constants';

export function mapParams(p: Record<string, any>): Record<string, string> {
  const qp = JSON.parse(JSON.stringify(p));
  mapSorting(qp);
  mapPagination(qp);
  if (!qp.search) {
    delete qp.search;
  }
  if (!qp.clinic) {
    delete qp.clinic;
  }
  return qp as Record<string, string>;
}

export function mapSorting(p: Record<string, any>) {
  if (p.sort) {
    p.sort.by = p.sort.by === 'date' ? 'created_at' : p.sort.by; // replace for backend key 'created_at'
    const order = p.sort.order === SortingOrder.DESC ? '' : '-';
    p.ordering =  order + p.sort.by;
  }
  delete p.sort;
}

export function mapPagination(p: Record<string, any>) {
  if (p.pageIndex && p.pageSize) {
    p.offset = (p.pageIndex - 1) * p.pageSize;
    p.limit = p.pageSize;
  }
  delete p.pageSize;
  delete p.pageIndex;
}

export function baseUrl() {
  return `${window.location.protocol}//${window.location.host}/`;
}

export function createSimulationLink(refCode: string) {
  return `${baseUrl()}simulation/${refCode}/ml`;
}

export function createSimulationClinicLink(patientRef: string, clinicRef: string) {
  return `${baseUrl()}simulation/${clinicRef}/${patientRef}/ml`;
}

export function createCapturingLink(refCode: string) {
  return `${baseUrl()}capturing/${refCode}`;
}
